/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SponsorDto } from '../../models/sponsor-dto';

export interface SponsorControllerFindAllV1$Params {
}

export function sponsorControllerFindAllV1(http: HttpClient, rootUrl: string, params?: SponsorControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SponsorDto>>> {
  const rb = new RequestBuilder(rootUrl, sponsorControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SponsorDto>>;
    })
  );
}

sponsorControllerFindAllV1.PATH = '/api/v1/sponsor';
